import React from 'react';
import Box from '@mui/material/Box';
import { Card, CardContent } from '@mui/material';
import { Title } from 'react-admin';
import Plot from 'react-plotly.js';

function StatisticheBoard({ datax, email, updatedAt }) {

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: 'Europe/Rome'
        }).format(date);
    };


    updatedAt = formatDate(updatedAt);

    // Crea le annotazioni per ogni barra del grafico
    const annotations = datax[0].y.map((value, index) => {
        // Controlla se il valore è null o undefined
        const textValue = value != null ? value.toString() : 0;
        return {
            x: datax[0].x[index],
            y: value,
            xref: 'x',
            yref: 'y',
            text: textValue,  // Converti il numero in stringa per l'annotazione
            showarrow: true,
            font: {
                family: 'Arial',
                size: 12,
                color: 'black'
            },
            arrowhead: 7,
            arrowsize: 1,
            arrowwidth: 1,
            ax: 0,  // Questo non modifica la posizione x dell'annotazione
            ay: value >= 0 ? -20 : 20  // Posiziona l'annotazione sopra o sotto la barra
        };
    });

    // Aggiungi un'annotazione per il titolo e l'email
    annotations.push({
        x: 0.5,
        y: 1.15,
        xref: 'paper',
        yref: 'paper',
        text: `<b>Grafico</b> | Statistiche per il candidato <b>${email}</b> - Ultima Modifica ${updatedAt}
            <br>
        `,
        showarrow: false,
        font: {
            family: 'Arial',
            size: 20,
            color: 'black'
        },
        align: 'center'
    });

    const layout = {
        title: "", // RISERVATO A NOME E COGNOME 
        barmode: 'group',
        margin: { l: 40, r: 40, t: 80, b: 100 },
        annotations: annotations
    };

    return (
        <div>
            <Card sx={{ mt: 10 }}>
                <Title title="STATISTICHE" />
                <CardContent>
                    {/* TODO: pulsanti */}
                </CardContent>
            </Card>

            <Box sx={{ mt: 5, display: 'flex', justifyContent: 'center' }}>
                <Plot
                    data={datax}
                    layout={layout}
                    useResizeHandler={true}
                    style={{ width: "100%", height: "100%" }}
                />
            </Box>

            <hr />
        </div>
    );
}

export default StatisticheBoard;
